import { render, staticRenderFns } from "./ProductQuickAdd.vue?vue&type=template&id=5586b2ce&"
import script from "./ProductQuickAdd.vue?vue&type=script&lang=js&"
export * from "./ProductQuickAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports